module.exports = __webpack_public_path__ + "img/cover-avon-fighting-breast-cancer.2f696241.jpg";